import React from 'react';
import MapFull from "./MapFull";
import {TrackerEndpoints, TractorOwnerEndpoints} from "../../common/ProxyEndpoints";
import TTLProxy from "../../common/TTLAsyncProxy";

const MapsOwner = () => {

    const proxy = TTLProxy.getInstance();

    function getOwnerId(){
        return proxy.getUserInfo().owner.id;
    }

    return <MapFull showOwner={false}
                    getTractorsUrl={() => TractorOwnerEndpoints.getTractors( getOwnerId() ).url}
                    getLocationsEndpoint={() => TrackerEndpoints.getTrackersLocation() }
                    sessionKey="maps_owner"/>

};

export default MapsOwner;


// WEBPACK FOOTER //
// ./src/views/Maps/MapOwner.js